export default __webpack_public_path__ + "static/feature-banner-checklist-overseas-af3144afc81efc5f7767dea69eafcfdc.jpg";